/** biome-ignore-all assist/source/useSortedAttributes: <> */

import { Role } from "@resamare/models";
import { ProtectedRoute } from "@resamare/widgets-shared";
import { Navigate, Route, Routes } from "react-router-dom";
import { AuthRoutes } from "@/features/auth";
import { LocationsRoutes } from "@/features/locations";
import { ScanRoutes } from "@/features/scan";
import { SessionsRoutes } from "@/features/sessions";
import { UnavailabilitiesRoutes } from "@/features/unavailabilities";
import { useScrollTop } from "@/hooks/useScrollTop";
import { DefaultRoute } from "./DefaultRoute";

export function AppRoutes() {
    useScrollTop();

    return (
        <Routes>
            <Route element={<ProtectedRoute allowedRole={Role.ADMIN} />}>
                <Route path="/" element={<DefaultRoute />} />
                <Route path="/sessions/*" element={<SessionsRoutes />} />
                <Route path="/scan/*" element={<ScanRoutes />} />
                <Route path="/locations/*" element={<LocationsRoutes />} />
                <Route path="/unavailabilities/*" element={<UnavailabilitiesRoutes />} />
            </Route>

            <Route element={<AuthRoutes />} path="/auth/*" />

            <Route element={<Navigate to="/" />} path="*" />
        </Routes>
    );
}
